export function getNoOfVotesText(noOfVotes: number) {
  if (noOfVotes === 0) return "0 opinii";
  if (noOfVotes === 1) return "1 opinia";

  if (noOfVotes > 4) return noOfVotes + " opinii";
  if (noOfVotes > 1) return noOfVotes + " opinie";
}
